// @intent Pure title-display helpers for Match3NativeRenderer — no Pixi deps, fully unit-testable.
// @flow (title, maxChars) -> displayTitle with ellipsis when truncated.
// @stale 2026-06-11 — extracted from renderer IIFE (visual-review Fix 2: ellipsis on title truncation).

/**
 * @intent Truncate a title string to fit within maxChars, appending '…' when the title is cut.
 *         Prefer one font-size step down before truncating (caller is responsible for trying smallerFont
 *         first; this function only handles the final cut). Returns '' when maxChars < 2.
 * @flow title.length <= maxChars → title unchanged; else slice to (maxChars - 1) + '…'.
 */
export function truncateTitle(title: string, maxChars: number): string {
  if (maxChars < 2) return '';
  if (title.length <= maxChars) return title;
  // Reserve one glyph slot for the ellipsis character so total length === maxChars.
  return title.slice(0, maxChars - 1) + '…';
}
